import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { MdAccessTime, MdCalendarMonth } from 'react-icons/md'

import { formatAddress } from 'services/address'
import { ContactForm, Container, GradientIcon, RainbowChip, Seo } from 'components'
import { Layout } from 'components/layouts'

const Page = () => {
  const { strapiGlobal } = useStaticQuery(graphql`
    query {
      strapiGlobal {
        ...ContactPageInfo
      }
    }
  `)

  const { address, ...data } = strapiGlobal as Queries.ContactPageInfoFragment

  return (
    <Layout>
      <Container>
        <section className='w-full flex flex-col md:flex-row gap-8 lg:gap-16 justify-between py-12 xl:py-20 relative'>
          <div className='flex flex-col gap-8 lg:gap-16 w-full md:w-1/2'>
            <div className='flex flex-col gap-4'>
              <RainbowChip label='Contato' />
              <h1 className='font-semibold text-lg md:text-xl lg:text-3xl'>Fale com a Hubs</h1>
              <h2 className='font-light text-md lg:text-lg'>
                Preencha o formulário para que nosso time de especialistas entre em contato com você. Estamos aqui para facilitar e ajudar
                com a burocracia dos meios convencionais de contabilidade!
              </h2>
            </div>

            <div className='flex flex-col xl:flex-row gap-8 xl:gap-0 justify-around'>
              <div className='flex flex-col gap-2 justify-center items-center bg-white/60 backdrop-blur-sm xl:bg-transparent rounded-2xl border-white xl:border-none border-t-2 border-l-2 p-3 xl:p-0'>
                <GradientIcon icon={<MdCalendarMonth size='1.5rem' />} />
                <p className='text-sm text-neutral-800'>{data.serviceWorkingDays}</p>
              </div>
              <div className='flex flex-col gap-2 justify-center items-center bg-white/60 xl:bg-transparent rounded-2xl border-white xl:border-none border-t-2 border-l-2 p-3 xl:p-0'>
                <GradientIcon icon={<MdAccessTime size='1.5rem' />} />
                <div className='flex flex-col items-center'>
                  <p className='text-sm text-neutral-800'>{data.serviceWorkingHours}</p>
                </div>
              </div>
            </div>

            <div className='flex flex-col gap-1'>
              <p className='text-sm font-semibold'>Hubs Contabilidade</p>
              <p className='text-sm'>{formatAddress(address as Queries.AddressInfoFragment)}</p>
              <p className='text-sm'>CNPJ: {data.cnpj}</p>
              <p className='text-sm'>CRC Hubs: {data.crc}</p>
              <p className='text-sm'>Responsável Técnico: {data.technicalResponsible}</p>
            </div>
          </div>

          <div className='w-full md:w-1/2 md:mt-12'>
            <ContactForm variant='alternative' />
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export const Head = () => {
  return (
    <Seo
      seo={{
        metaTitle: 'Contabilidade Digital | Contabilidade Completa',
      }}
    />
  )
}

export const query = graphql`
  fragment AddressInfo on STRAPI__COMPONENT_SHARED_ADDRESS {
    id
    name
    street
    number
    complement
    neighborhood
    city
    state
    postalCode
  }

  fragment ContactPageInfo on STRAPI_GLOBAL {
    id
    serviceWorkingDays
    serviceWorkingHours
    contactPhone
    linkAppWeb
    cnpj
    crc
    technicalResponsible
    address {
      ...AddressInfo
    }
  }
`

export default Page
